import React, { useState } from "react";
import FullPaymentForm from "components/payments/FullPaymentForm";
import StripeForm from "components/payments/StripeForm";

export default function (props) {
  /* eslint-disable no-unused-vars */
  const [paypalActions, setPaypalActions] = useState({});
  /* eslint-enable no-unused-vars */
  const paypalHandlers = {
    // example of getting paypal actions into parent component.
    onAuthorize: () => {},
    onCancel: () => {},
    onClick: () => {},
    onError: () => {},
    payment: () => {},
    validate: (actions) => {
      setPaypalActions(actions);
    }
  };

  const stripeHandlers = {
    onError: () => {},
    onSuccess: () => {}
  };
  return (
    <>
      <div className="row">
        <h2>Full Payment Form</h2>
        <FullPaymentForm
          paypalHandlers={paypalHandlers}
          paypalEnvironment="sandbox"
          subscriptionType="annual"
          setupIntentsPath={props.setupIntentsPath}
          stripeReturnUrl=""
          stripeHandlers={stripeHandlers}
        />
      </div>
      <div className="row">
        <h2>Payment Form without Paypal</h2>
        <StripeForm
          subscriptionType="annual"
          setupIntentsPath={props.setupIntentsPath}
          stripeReturnUrl=""
          stripeHandlers={stripeHandlers}
          formClass="payment-form"
        />
      </div>
    </>
  );
}
